import type { CalculationType } from "@msuite/utils/types";

type InitCalculationProps =
	| { type: Extract<CalculationType, "parsc">; referenceId: string }
	| {
			type: Extract<CalculationType, "offer">;
	  };

export function handleOnInitializeCalculation(props: InitCalculationProps) {
	const currentUrl = new URL(window.location.href);
	const encodedUrl = encodeURIComponent(`${currentUrl.pathname}${currentUrl.search}`);
	let url = "";
	if (props.type === "parsc") {
		url = `/calculations/init?type=parsc&identifier=${props.referenceId}`;
	} else {
		url = "/calculations/init?type=offer";
	}
	url += `&returnTo=${encodedUrl}`;
	window.open(url, "_blank");
}
